import * as R from 'ramda';
import *  as axios from 'axios';
import * as ImpressionActionTypes from '../../constants/actiontypes/backoffice/impression';
import * as impressionUrl from '../../constants/webapi/backoffice/impression';
import { getAuthenticationUrl } from '../../constants/webapi/auth';

export function GetUserLettersToPrint(pageNumber) {
	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && isNaN(page)) {
		throw new Error("pageNumber must be null or an integer");
	}

	return (dispatch) => {
		dispatch({ type: ImpressionActionTypes.FETCH_USER_LETTERS_TO_PRINT_REQUEST });
		return axios.get(impressionUrl.userlettersToPrintUrl(new URLSearchParams({
			pageNumber: R.isNil(pageNumber) ? 0 : pageNumber - 1,
			pageSize: 50
		})))
			.then((response) => {
				dispatch({
					type: ImpressionActionTypes.FETCH_USER_LETTERS_TO_PRINT_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ImpressionActionTypes.FETCH_USER_LETTERS_TO_PRINT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}


export function GetUserById(userId) {
	return axios.get(impressionUrl.getUserByIdUrl(userId))
		.then((response) => {
			return response.data;

		})
		.catch((error) => {
			throw error;
		});
}

export function GetLetterById(letterId) {
	return axios.get(impressionUrl.getLetterByIdUrl(letterId))
		.then((response) => {
			return response.data;

		})
		.catch((error) => {
			throw error;
		});
}

export function DownloadLettersAndReco(userLetterIds) {
	return axios.post(impressionUrl.letterAndRecoContentUrl(), userLetterIds, { responseType: "arraybuffer" })
		.then((response) => {
			var file = new Blob([response.data], { type: response.headers["content-type"] });
			var fileurl = window.URL.createObjectURL(file);
			window.open(fileurl);
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
};


export function GenerateBordereau(userLetterIds) {
	return axios.post(impressionUrl.generateBoredereauUrl(), userLetterIds, { responseType: "arraybuffer" })
		.then((response) => {
			var file = new Blob([response.data], { type: response.headers["content-type"] });
			var fileurl = window.URL.createObjectURL(file);
			window.open(fileurl);
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
};